import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';

import useAxios from '../useAxios';

import { COMPANY_ENDPOINT } from '../../constants/apiEndpoints';

import { SignUpRequest } from '../../@types/company';

export const useSignUp = () => {
  const axios = useAxios();

  return useMutation((payload: SignUpRequest) =>
    axios.post<unknown, AxiosResponse<unknown, SignUpRequest>, SignUpRequest>(
      COMPANY_ENDPOINT,
      payload,
    ),
  );
};
